<!-- Trigger : label optionnel + bouton "?" avec glow -->
<div class="aide-trigger flex-row align-center gap-4"
     #trigger="popoverElement"
     [closeOnClickOutside]="true"
     [popoverTrigger]="popoverTpl"
     popoverAnimation="zoom">

  @if (label()) {
    <span class="caption on-background-alt aide-label">{{ label() }}</span>
  }

  <button class="aide-btn" type="button">
    <span class="aide-btn-glow"></span>
    <mat-icon class="aide-btn-icon">help</mat-icon>
  </button>
</div>

<!-- Popover (ng-template → rendu UNIQUEMENT à l'ouverture) -->
<ng-template #popoverTpl>
  <div class="aide-popover" [style.max-width.px]="maxWidth()">

    <!-- ===== Mode 1 : content projection via <ng-template vlAideContent> ===== -->
    @if (contentTpl(); as tpl) {
      <ng-container [ngTemplateOutlet]="tpl.tpl"/>
    }

    <!-- ===== Mode 2 : input [sections] programmatique ===== -->
    @for (section of sections(); track $index) {
      @switch (section.type) {
        @case ('text') {
          <div class="aide-section-text">
            @if (section.title) {
              <span class="aide-section-title">{{ section.title }}</span>
            }
            <div class="aide-html-content" [innerHTML]="section.html"></div>
          </div>
        }
        @case ('highlight') {
          <div class="aide-section-highlight">
            @if (section.title) {
              <span class="aide-section-highlight-title">{{ section.title }}</span>
            }
            <div class="aide-html-content" [innerHTML]="section.html"></div>
          </div>
        }
      }
    }

  </div>
</ng-template>
